<template>
  <div class="flex gap-2">
    <a
      :href="androidHref"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-play-badge-link"
    >
      <div class="w-[175px] h-[60px] bg-white border rounded border-gray-500 p-3 cursor-pointer">
        <img width="150" height="33" src="/google-play.png" alt="Disponível no Google Play" />
      </div>
    </a>
    <a :href="iosHref" target="_blank" rel="noopener noreferrer" data-testid="app-store-badge-link">
      <div class="w-[175px] h-[60px] bg-white border rounded border-gray-500 p-3">
        <img width="150" height="33" src="/app_store.png" alt="Baixar na App Store" />
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ANDROID_STORE_URL, IOS_STORE_URL } from '@/utils/appStoreLinks'

const props = defineProps<{ androidUrl?: string; iosUrl?: string }>()

const androidHref = computed(() => props.androidUrl || ANDROID_STORE_URL)
const iosHref = computed(() => props.iosUrl || IOS_STORE_URL)
</script>
